import React from "react";
import PKORefundChargebackReportTable from "./PKORefundChargebackReportTable";

const PKORefundChargebackReport = () => (
  <div>
    <PKORefundChargebackReportTable />
  </div>
);

PKORefundChargebackReport.ROUTE = {
  url: "pko-refunds",
  name: "PKO Refunds",
  icon: "chart bar",
  description: "View PKO refund and chargeback status changes",
};

export default PKORefundChargebackReport;
